module.exports = __webpack_public_path__ + "img/banner_id.e100bdcf.png";